import { type ReactNode } from 'react'
import styles from './DetailsView.module.css'

export interface DetailsViewProps {
  children: ReactNode
}

export function DetailsView({ children }: DetailsViewProps) {
  return <div className={styles.root}>{children}</div>
}

export interface JobDetailsViewProps {
  onboarding: ReactNode
  documentation: ReactNode
  children: ReactNode
}

export function JobDetailsView({
  onboarding,
  documentation,
  children,
}: JobDetailsViewProps) {
  return (
    <div className={styles.root}>
      <div className={styles.onboardingWrapper}>{onboarding}</div>

      <div className={styles.docsWrapper}>{documentation}</div>

      {children}
    </div>
  )
}

export interface DetailsDocumentationStackProps {
  children: ReactNode
}

// Stacks the documentation cards within a single cell of the details grid,
// which would otherwise place them next to each other horizontally.
export function DetailsDocumentationStack({
  children,
}: DetailsDocumentationStackProps) {
  return <div className={styles.txfDocumentationWrapper}>{children}</div>
}
